import $ from 'jquery';
import connectFilterNotifications from 'legacy/javascripts/notification.js';

$(function () {
  var setupTeamTree = function () {
    var includeDeactivated = false;
    var $root = $('#js-employee-tree-root');

    if (!$root.length) {
      return;
    }

    function resetCollapse() {
      $('#js-employee-tree-root .subgroup').addClass('hidden');
      $('#js-employee-tree-root .node:not(.js-deactivated-employee)').addClass(
        'hidden',
      );
      $('#js-employee-tree-root > .subgroup').removeClass('hidden');
      $(
        '#js-employee-tree-root > .subgroup > .node:not(.js-deactivated-employee)',
      ).removeClass('hidden');
      $('#js-employee-tree-root .js-node-content i')
        .addClass('fa-folder')
        .removeClass('fa-folder-open');

      $('#js-employee-tree-root').removeClass('hidden');
    }

    function bindAccordianClicks() {
      var nodeSelector = includeDeactivated
        ? '.node'
        : '.node:not(.js-deactivated-employee)';

      $root.on('click', '.js-node-content', function () {
        var $subGroup = $(this).parent('.node').children('.subgroup');
        var slideSpeed = 200;

        if ($subGroup.is(':visible')) {
          $subGroup.slideUp({
            duration: slideSpeed,
            complete: function () {
              $subGroup.children(nodeSelector).addClass('hidden');
            },
          });
        } else {
          $subGroup.children(nodeSelector).removeClass('hidden');
          $subGroup.slideDown({
            duration: slideSpeed,
            start: function () {
              $subGroup.removeClass('hidden');
            },
          });
        }
        $(this)
          .children('i')
          .toggleClass('fa-folder')
          .toggleClass('fa-folder-open');
      });
    }

    function bindCheckBoxes() {
      $root.on('click', '.js-employee-checkbox', function (e) {
        e.stopPropagation();
      });
      $root.on('change', '.js-employee-checkbox', updateEmployeeIds);
    }

    function updateEmployeeIds() {
      var query;
      var childAdds = $(this)
        .parents('.node, #js-employee-tree-root')
        .eq(0)
        .find('ul.subgroup')
        .find('.js-employee-checkbox');
      //select this box
      if (this.checked) {
        $(this).addClass('added');
        // propagate down if folder
        childAdds.prop('checked', true).addClass('added');
      } else {
        $(this).removeClass('added');
        // propagate down if folder
        childAdds.prop('checked', false).removeClass('added');
      }

      // assemble new query set by node IDs
      query = $('.added', $root)
        .closest('.node')
        .map(function () {
          return $(this).data('node-id');
        });

      $('#employee_ids, #group_ids').val(query.toArray().join()).change();
      // execute stream with new filters
    }

    /////////////////////////////
    //      options links      //
    /////////////////////////////
    function selectAll() {
      $root
        .find('.js-employee-checkbox')
        .eq(0)
        .prop('checked', true)
        .trigger('change');
    }

    function deselectAll() {
      $root
        .find('.js-employee-checkbox')
        .eq(0)
        .prop('checked', false)
        .trigger('change');
    }

    function showSelected() {
      var matches;
      resetCollapse();

      matches = $('.added').closest('.node');
      matches.each(function () {
        $(this).parents('.subgroup').removeClass('hidden');
        $(this).parents('.subgroup').children('.node').removeClass('hidden');
        $(this)
          .parents('.node, #js-employee-tree-root')
          .children('.js-node-content')
          .children('i')
          .removeClass('fa-folder')
          .addClass('fa-folder-open');
      });
    }

    function bindMassOptions() {
      $('.js-select-all.teams').click(selectAll);
      $('.js-deselect-all.teams').click(deselectAll);
      $('.js-show-selected.teams').click(showSelected);
    }

    /////////////////////////////
    //       'only' links      //
    /////////////////////////////
    function bindOnlyLinks() {
      $root.on('click', '.only-link', function (e) {
        e.stopPropagation();

        $('.js-employee-checkbox.added')
          .prop('checked', false)
          .removeClass('added');
        $(this)
          .siblings('.js-employee-checkbox')
          .prop('checked', true)
          .addClass('added')
          .trigger('change');
      });
    }

    function bindNodeSelectors() {
      bindCheckBoxes();
      bindOnlyLinks();
      bindMassOptions();
    }

    /////////////////////////////
    //     search to filter    //
    /////////////////////////////
    function hideAll() {
      $(
        '#js-employee-tree-root .node, #js-employee-tree-root .subgroup, #js-employee-tree-root .js-node-content',
      ).addClass('hidden');
    }

    function showAll() {
      var nodeSelector = includeDeactivated
        ? '.node'
        : '.node:not(.js-deactivated-employee)';
      $('#js-employee-tree-root ' + nodeSelector).removeClass('hidden');
      $(
        '#js-employee-tree-root .subgroup, #js-employee-tree-root .js-node-content',
      ).removeClass('hidden');
    }

    function resetList() {
      showAll();
      resetCollapse();
      unhighlight();
      $('.match').removeClass('match');
      $('#js-employee-tree-search .action .fa-search').removeClass('hidden');
      $('#js-employee-tree-search .action .fa-times').addClass('hidden');
    }

    function highlightMatches($matches, query) {
      var term = query.replace(/(\s+)/, '(<[^>]+>)*$1(<[^>]+>)*');
      var pattern = new RegExp('(' + term + ')', 'i');

      $matches.each(function () {
        var srcStr = this.innerHTML;
        srcStr = srcStr.replace(pattern, '<mark>$1</mark>');
        srcStr = srcStr.replace(
          /(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/,
          '$1</mark>$2<mark>$4',
        );

        this.innerHTML = srcStr;
      });
    }

    function unhighlight() {
      $('mark').contents().unwrap();
    }

    function onlyShowMatches($matches, query) {
      // make them all visible (and their parents as needed)
      hideAll();
      unhighlight();

      if ($matches.length) {
        $matches
          .parents()
          .removeClass('hidden')
          .children('.js-node-content')
          .removeClass('hidden');
        $matches
          .parents('.node')
          .children('.js-node-content')
          .children('i')
          .removeClass('fa-folder')
          .addClass('fa-folder-open');
        $matches
          .parents('.node')
          .children('.js-node-content')
          .addClass('match');
        // if match is parent, show all children
        highlightMatches($matches, query);
      }
    }

    function debounce(func, delay, { leading } = {}) {
      let timerId;

      return function (...args) {
        const ctx = this;

        if (!timerId && leading) {
          func.apply(ctx, args);
        }
        clearTimeout(timerId);

        timerId = setTimeout(() => func.apply(ctx, args), delay);
      };
    }

    function bindSearch() {
      var $allNames = $('#js-employee-tree-root .name');
      var $activeNames = $allNames.not('.deactivated');
      var $input = $('#js-employee-tree-search input');
      var $startSearchBtn = $('#js-employee-tree-search .action .fa-search');
      var $clearSearchBtn = $('#js-employee-tree-search .action .fa-times');

      var searchFunction = function () {
        var $matches;
        var $namesToFilter;
        var query = $input.val().toLowerCase();

        if (!query) {
          $startSearchBtn.removeClass('hidden');
          $clearSearchBtn.addClass('hidden');

          resetList();
        } else {
          $startSearchBtn.addClass('hidden');
          $clearSearchBtn.removeClass('hidden');

          $namesToFilter = includeDeactivated ? $allNames : $activeNames;
          $matches = $namesToFilter.filter(function () {
            if (this.innerText.toLowerCase().indexOf(query) !== -1) {
              return true;
            } else {
              return false;
            }
          });

          onlyShowMatches($matches, query);
        }
      };

      $input.keyup(
        debounce(function () {
          if (this.value.length >= 2) {
            searchFunction();
          }
        }, 500),
      );

      $input.keypress(function (e) {
        var enterKeyCode = 13;
        if (e.which == enterKeyCode) {
          searchFunction();
          return false;
        }
      });

      $clearSearchBtn.click(function () {
        $input.val('').focus();
        resetList();
      });

      $startSearchBtn.click(searchFunction);
    }

    function bindDeactivated() {
      var $checkbox = $('.js-filter-deactivated :checkbox');
      $checkbox.change(function () {
        var $deactivated = $('.js-deactivated-employee');
        if ($checkbox.is(':checked')) {
          includeDeactivated = true;
          $deactivated.removeClass('hidden');
        } else {
          includeDeactivated = false;
          $('.js-deactivated-employee :checkbox')
            .prop('checked', false)
            .removeClass('added');
          $deactivated.addClass('hidden');
          updateEmployeeIds();
        }
      });
    }

    function bindClearFilters() {
      $('.js-clear-filters').click(deselectAll);
    }

    function checkEmployees() {
      var ids = connectFilterNotifications.getEmployeeIds();
      connectFilterNotifications
        .getEmployeeIds()
        .split(',')
        .forEach(function (id) {
          id &&
            $("[data-id='" + id + "'] :checkbox")
              .prop('checked', true)
              .addClass('added');
        });

      $('#employee_ids').val(ids);
    }

    bindAccordianClicks();
    bindNodeSelectors();
    bindDeactivated();
    bindSearch();
    bindClearFilters();
    showSelected();

    if ($('.js-filter-form').data('clientFilter')) {
      checkEmployees();
    }
    $root.removeClass('hidden');

    setupTeamTree.clearSelection = deselectAll;
  };

  setupTeamTree();
  $(document).on('leaderboard-page-update', setupTeamTree);

  $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
    if ($(e.target).attr('href') === '#groups-leaderboard') {
      setupTeamTree.clearSelection();
    }
  });
});
